<template>
	<div>
		<div class="items">
			<div class="items-body">

				<div class=inputCard>
				<span class="apiKeys">{{ $t('companyName') }}</span>
				<!-- <quick-edit 
					type="text"
					maxlength=40  
					:emptyText="$t('companyNameMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('name')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.name">
				</quick-edit> -->
				<br />
				<span class="field-value active" v-show="!showField('name')" @click="focusField('name')">{{client.name}}</span>
				<input 
					v-show="showField('name')"
					class="field-value form-control inactive"
					v-model="client.name" 
					type="text" 
					maxlength="50"
					@focus="focusField('name')" 
					@blur="$v.client.name.$touch(); blurField('name')"
				/>
				<template v-if="$v.client.name.$invalid">
					<div v-if="!$v.client.name.required" class="errorMessage1">{{ $t('companyNameReq') }}</div>
				</template>
				<br/>
				<template v-if="$v.client.name.$invalid">
					<p v-if="!$v.client.name.maxLength" class="errorMessage">
					{{ $t('companyNameLength') }}
					</p>
				</template>
				</div>
				<div class="nameWrapper">
					<div class=inputCard>
						<span class="apiKeys">{{ $t('vatNo') }} </span>
						<!-- <quick-edit 
							type="text"
							maxlength=20  
							:emptyText="$t('companyVatNoMissing')"
							:placeholderValue="$t('companyName')" 
							:buttonOkText="'✔'"
							input
							@input="changeClientDetails('vat_no')"
							:buttonCancelText="'X'"
							:classes="vueQuickEditClasses" 
							v-model="client.vat_no">
						</quick-edit> -->
						<br />
						<span class="field-value active" v-show="!showField('vat_no')" @click="focusField('vat_no')">{{client.vat_no}}</span>
						<input 
							v-show="showField('vat_no')"
							class="field-value form-control inactive"
							v-model="client.vat_no" 
									oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
							type="number" 
							minLength="8"
							maxlength="8"
							@focus="focusField('vat_no')" 
							@blur="$v.client.vat_no.$touch(); blurField('vat_no')"
						/>
						<template v-if="$v.client.vat_no.$error">
							<div v-if="!$v.client.vat_no.required" class="errorMessage1">{{ $t('vatNoReq') }}</div>
						</template>
						<template v-if="$v.client.vat_no.$invalid">
							<p v-if="!$v.client.vat_no.minLength" class="errorMessage">
							{{ $t('companyVatNoLength') }}
							</p>
						</template>
					</div>
					<div class=inputCard>
						<span class="apiKeys">{{ $t('liableForVAT') }}</span>
							<v-radio-group 
								id="liableForVAT" 
								v-model="client.liable_for_vat" 
								@change="blurField('liable_for_vat')"
								inline
							>
								<v-radio :label="$t('no')" value="0"></v-radio>
								<v-radio :label="$t('yes')" value="1"></v-radio>
							</v-radio-group>	
					</div>
				</div>

				<div class=inputCard>
				<span class="apiKeys">{{ $t('companyAddress') }} </span>
				<!-- <quick-edit 
					type="text"
					maxlength=40  
					:emptyText="$t('companyAddressMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('address')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.address">
				</quick-edit> -->
				<br />
				<span class="field-value active" v-show="!showField('address')" @click="focusField('address')">{{client.address}}</span>
				<input 
					v-show="showField('address')"
					class="field-value form-control inactive"
					v-model="client.address" 
					type="text" 
					maxlength="30"
					@focus="focusField('address')" 
					@blur="$v.client.address.$touch(); blurField('address')"
				/>
				<template v-if="$v.client.address.$invalid">
					<div v-if="!$v.client.address.required" class="errorMessage1">{{ $t('addressReq') }}</div>
				</template>
				<template v-if="$v.client.address.$invalid">
					<p v-if="!$v.client.address.maxLength" class="errorMessage">
					{{ $t('companyAddressLength') }}
					</p>
				</template>
				</div>

				<div class=inputCard>
				<span class="apiKeys">{{ $t('companyAddressNo') }} </span>
				<br />
				<span class="field-value active" v-show="!showField('address_no')" @click="focusField('address_no')">{{client.address_no}}</span>
				<input 
					v-show="showField('address_no')"
					class="field-value form-control inactive"
					v-model="client.address_no" 
					type="text" 
					maxlength="5"
					@focus="focusField('address_no')" 
					@blur="$v.client.address_no.$touch(); blurField('address_no')"
				/>
				<template v-if="$v.client.address_no.$error">
					<div v-if="!$v.client.address_no.required" class="errorMessage1">{{ $t('addressNoReq') }}</div>
				</template>
				<template v-if="$v.client.address_no.$invalid">
					<p v-if="!$v.client.address_no.maxLength" class="errorMessage">
					{{ $t('companyAddressNoLength') }}
					</p>
				</template>
				</div>

				<div class=inputCard>
				<span class="apiKeys">{{ $t('buildingNo') }} 
					<b-button
						class="help-tip"
						v-b-tooltip.hover
						:title="$t('buildingNoTooltip')"
					>?</b-button>
				</span>
				<br />
				<span class="field-value active" v-show="!showField('building_no')" @click="focusField('building_no')">{{client.building_no}}</span>
				<input 
					v-show="showField('building_no')"
					class="field-value form-control inactive"
					v-model="client.building_no"
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					maxlength="10"
					type="number" 
					@focus="focusField('building_no')" 
					@blur="$v.client.building_no.$touch(); blurField('building_no')"
				/>
				<template v-if="$v.client.building_no.$error">
					<div v-if="!$v.client.building_no.required" class="errorMessage1">{{ $t('buildingNoReq') }}</div>
				</template>
				</div>

				<div class=codeCityWrapper>
				<div class=inputCard>
					<span class="apiKeys">{{ $t('postalCode') }} </span>
					<!-- <quick-edit 
					type="number"
					maxlength=10  
					:emptyText="$t('companyPostalCodeMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('postal_code')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClassesShortInput" 
					v-model="client.postal_code">
					</quick-edit> -->
					<br />
					<span class="field-value active" v-show="!showField('postal_code')" @click="focusField('postal_code')">{{client.postal_code}}</span>
					<input 
					v-show="showField('postal_code')"
					class="field-value form-control inactive"
					v-model="client.postal_code" 
					type="text" 
					maxlength="10"
					@focus="focusField('postal_code')" 
					@blur="$v.client.postal_code.$touch(); blurField('postal_code')"
					/>
					<template v-if="$v.client.postal_code.$error">
					<div v-if="!$v.client.postal_code.required" class="errorMessage1">{{ $t('postalCodeReq') }}</div>
					</template>
					<template v-if="$v.client.postal_code.$invalid">
					<p v-if="!$v.client.postal_code.maxLength" class="errorMessage">
						{{ $t('companyPostalCodeLength') }}
					</p>
					</template>
				</div>
				</div>
				<div class=inputCard>
					<span class="apiKeys">{{ $t('city') }} 
						<b-button
							class="help-tip"
							v-b-tooltip.hover
							:title="$t('KOTooltip')"
						>?</b-button>
					</span>
					<!-- <quick-edit 
					type="text"
					maxlength=20  
					:emptyText="$t('companyCityMissing')"
					:placeholderValue="$t('companyName')" 
					:buttonOkText="'✔'"
					input
					@input="changeClientDetails('city')"
					:buttonCancelText="'X'"
					:classes="vueQuickEditClasses" 
					v-model="client.city">
					</quick-edit> -->

					<multiselect
					v-model="client.city"
					:options="cityNames"
					:searchable="true"
					:close-on-select="true"
					:placeholder="$t('selectCity')"
					:show-labels="false"
					:class="{ error: $v.client.city.$error }"
					@input="changeCity()"
					@blur="$v.client.city.$touch();"
					></multiselect>

					<template v-if="$v.client.city.$error">
					<div v-if="!$v.client.city.required" class="errorMessage1">{{ $t('cityReq') }}</div>
					</template>
					<!-- <br />
					<br /> -->
					<!-- <template v-if="$v.client.city.$invalid">
					<p v-if="!$v.client.city.maxLength" class="errorMessage">
						{{ $t('companyCityLength') }}
					</p>
					</template> -->
				</div>              

				<div class=inputCard>
					<span class="apiKeys">{{ $t('region') }} </span>

					<multiselect
					v-model="client.region"
					maxHeight=100
					:options="regionNames"
					:searchable="true"
					:close-on-select="true"
					:placeholder="$t('selectRegion')"
					:class="{ error: $v.client.region.$error }"
					@input="changeRegion()"
					@blur="$v.client.region.$touch();"
					></multiselect>

					<!-- :show-labels="false" -->
					<template v-if="$v.client.region.$error">
					<div v-if="!$v.client.region.required" class="errorMessage1">{{ $t('regionReq') }}</div>
					</template>
				</div>

				<div class=inputCard>
				<span class="apiKeys">{{ $t('country') }} </span>
				<div class="countryStatic">{{ client.country }}</div>
	<!-- 
				<country-select 
					v-model="client.country" 
					:country="client.country" 
					class="field inputStyle"
					countryName="true"
					autocomplete="true"
					removePlaceholder="false"
					usei18n="false"
					:disabled="!isEditing"
					/> -->
				</div>
				<hr>
				<p class="editInstructions">{{ $t('editInstructions') }}</p>
				<!-- <div style="margin: auto;">
				<button :disabled="$v.$invalid" class="save-btn" v-if="isEditing" @click="changeClientDetails"><span class="save-txt">{{ $t('save') }}</span></button>
				</div> -->
				
				<!-- <div class=inputCard>
				<span class="apiKeys">{{ $t('website') }}: </span>
				<input 
					class="inactive" 
					v-model="client.website_url" 
					type="text" 
					:disabled="!isEditing"
				/>
				</div> -->
			</div>
		</div>

	</div>
</template>

<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";

export default {
	components: {
	},
	data() {
		return {
			id: this.client.id,
			cityNames: [],
			cascadianData: [],
			regionNames: [],
			vueQuickEditClasses: {
				wrapper: 'form-group form-inline',
				input: 'formControl input-sm',
				buttons: 'btn-group btn-group-sm',
				buttonOk: 'btn saveBtn',
				buttonCancel: 'btn closeBtn',
			},
			vueQuickEditClassesShortInput: {
				wrapper: 'form-group form-inline',
				input: 'formControl short input-sm',
				buttons: 'btn-group btn-group-sm',
				buttonOk: 'btn saveBtn',
				buttonCancel: 'btn closeBtn',
			},
			editField : ''
		}
	},  
	validations: {
		client: {
			name: { required, maxLength: maxLength(50) },
			address_no: { required, maxLength: maxLength(10) },
			address: { required, maxLength: maxLength(30) },
			building_no: { required },
			postal_code: { required, maxLength: maxLength(10) },
			city: { required },
			region: { required },
			country: { required },
			vat_no: { required, minLength: minLength(8), maxLength: maxLength(8) },
			liable_for_vat: { required }
		}
	},
	async mounted() {
		this.client.liable_for_vat = this.client.liable_for_vat.toString()
		this.cityNames = await this.$store.dispatch('client/fetchCascadianCityList', this.$i18n.locale)
		if (this.client.name === null) this.client.name = ''
		if (this.client.vat_no === null) this.client.vat_no = ''
		if (this.client.address === null) this.client.address = ''
		if (this.client.address_no === null) this.client.address_no = ''
		if (this.client.building_no === null) this.client.building_no = ''
		if (this.client.postal_code === null) this.client.postal_code = ''
		if (this.client.country === null) this.client.country = ''
	},
	methods: {
		focusField(name){
			this.editField = name;
		},
		blurField(name){
			this.editField = '';
			this.changeClientDetails(name)
		},
		showField(name){
			return (this.client[name] == '' || this.editField == name)
		},
		changeClientDetails(propertyName) {
			if (this.client[propertyName] === "" || this.$v.client[propertyName].$error) {
				return
			}
			// if (
			//   confirm('are you sure? This will rewrite excisting company details')
			// ) 
			{
				if (this.client.postal_code === "") this.client.postal_code = null
				this.$store.dispatch('client/editClient', this.client)
			}
		},
		async changeCity() {
			this.client.region = null
			const cityJson = {
				lang: this.$i18n.locale,
				city: this.client.city
			}
			this.cascadianData = await this.$store.dispatch('client/fetchCascadianRegion', cityJson)
			this.regionNames = this.cascadianData.map(a => a.municipality)
		},
		changeRegion() {
			const selectedCascadian = this.cascadianData.filter((data) => {
				return data.municipality === this.client.region
			})
			this.client.cascadian_number = selectedCascadian[0].cascadian_number
			this.$store.dispatch('client/editClient', this.client)
		}
	},
	props: {
		client: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>

$sec:#fff;
$primary: #b97b42;
$dark-pri:rgb(44, 62, 80);
* {
  box-sizing: border-radius;
 }

.active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 600;
    font-style: normal !important;
}
.inactive {
    background-color: var(--primarySuperLight);
    border-radius: 3.5px;
    // font-style: italic;
}

.inputCard {
  padding: 10px;
}

.errorMessage {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-top: 12px;
  padding-left: 5px;
  color: var(--primaryDark);
  font-size: 0.58em;
}

.nameWrapper {
  display: flex;
}
.nameWrapper > .inputCard {
  margin-right: 20px;
}
.errorMessage1 {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-top: 4px;
  padding-left: 5px;
  color: var(--primaryDark);
  font-size: 0.58em;
}

.editInstructions {
color: var(--grey);
font-size: 0.8em;
} 

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	border-radius: 5px;
	padding: 0.3em;
	letter-spacing: 3px;
	max-width: 150px;
	width:100%;
	margin-left: 30px;
	margin-bottom: 20px;
}

.save-btn {
    background: var(--primaryDark);
    color: var(--bright);
    padding: 0.3em;
    margin: auto !important;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    width: 120px;
    height: 30px;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.items {
  width: 100%;
  max-width: 750px;
  background: var(--bright);
  box-shadow: 0 3px 6px rgba(black,0.16), 0 3px 6px rgba(black,0.23);
  border-top: 10px solid var(--primaryDark);
}

.items-head p{
  padding: 5px 20px;
  margin: 10px;
  color: var(--bg);
  font-weight: bold;
  font-size: 20px;
}

.items-head hr {
  width: 20%;
  margin: 0px 30px;
  border: 1px solid $dark-pri;
}
.apiKeys {
  color: var(--grey);
  text-align: left;
  font-size: 0.9vw;
}

.help-tip {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  text-align: center;
  background-color: var(--bg) !important;
  padding: 1px;
  width: 24px;
  height: 24px;
  font-size: 12px;
  margin-left: 5px !important;
  margin-bottom: 3px !important;
}

.questionMark:hover {
  background-color: var(--primaryDark) !important;
}
.items-body {
  padding: 10px;
  text-align: left;
  margin-left: 20px;
}

.items-body-content {
  padding: 10px;
  padding-right: 0px;
  display: grid;
  grid-template-columns: 10fr 1fr;
  // background-color: lightblue;
  font-size: 13px;
  grid-gap: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  
}

.items-body-content:hover {
  border-radius: 15px;
  border: 1px solid $dark-pri;
}

.items-body-content i {
  align-self: center;
  font-size: 15px;
  color: $dark-pri;
  font-weight: bold;
  animation: icon 1.5s infinite forwards;
}

.countryStatic {
  color: var(--bg) !important;
  font-weight: 600;
  font-size: 1.2em;
}

.codeCityWrapper {
  display: flex;
}

.save-txt {
  // margin-left: 5px;
  padding: 7px;
}

// custom css for quickEdit //
.vue-quick-edit__link--is-clickable {
}
.vue-quick-edit__button.vue-quick-edit__button--cancel {
}
// END of custom css for quickEdit //


@keyframes icon {
  0%,100%{
    transform: translate(0px);
  }
  50% {
    transform: translate(3px);
  }
}


@media screen and (max-width: 900px) {
  .apiKeys {
    font-size: 1.55vw;
  }
}
@media screen and (max-width: 600px) {
  .apiKeys {
    font-size: 3vw;
  }
  .field {
    width: 100%;
  }
  .errorMessage {
  margin-top: -15px;
}
}

@media screen and (max-width: 400px) {
  .add-btn {
    font-size: 0.6em;
  }
  .inputCard {
  padding: 0px;
}
  .apiKeys {
    font-size: 3vw;
  }
.items-body {
  margin-left: 0px;
}
.codeCityWrapper > .inputCard {
  margin-right: 10px;
}
.nameWrapper {
	margin-right: 0px !important;
	display: block;
  }
}

</style>